import { render, staticRenderFns } from "./GenerateRecoveryCodes.vue?vue&type=template&id=77900cd4&scoped=true"
import script from "./GenerateRecoveryCodes.vue?vue&type=script&lang=js"
export * from "./GenerateRecoveryCodes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77900cd4",
  null
  
)

export default component.exports